import React, { useContext, useEffect } from "react";
import "./Withdrawal_History.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Withdrawal_History_card from "./Withdrawal_History_card/Withdrawal_History_card";
import No_data from "../../Common/No_data/No_data";
import { Context } from "../../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import { GetAllWithdrawHistory } from "../../../features/wallet/slice";

function Withdrawal_History() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signin } = useContext(Context)

  const withdrawHistory = useSelector((state) => state.wallet);


  useEffect(() => {
    if (signin)
      dispatch(GetAllWithdrawHistory({

      }))
  }, [dispatch, signin])
  return (
    <section className="Withdrawal_History">
      <div className="withdrawal_header History_header">
        <div className="header-left">
          <span className="header_icon">
            <FontAwesomeIcon icon={faFileLines} />
          </span>
          <h4>Withdrawal History</h4>
        </div>
      </div>
      {withdrawHistory?.data?.length > 0 ?
        <Withdrawal_History_card status="Completed" badge="Withdraw" withdrawHistory={withdrawHistory} showQuery />
        :
        <No_data />
      }

      <div className="text-center">
        <Button
          className="btn-register mb-3"
          onClick={() => navigate("/withdrawal-history")}
        >
          All History
        </Button>
      </div>


    </section>
  );
}

export default Withdrawal_History;
